import { render, staticRenderFns } from "./ItemChatMessage.vue?vue&type=template&id=7808f632&scoped=true&lang=pug&"
import script from "./ItemChatMessage.vue?vue&type=script&lang=js&"
export * from "./ItemChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./ItemChatMessage.vue?vue&type=style&index=0&id=7808f632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7808f632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
